import React, { useState, useEffect } from "react";
import Select from "../../../components/ui/Select";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";

const FilterControls = ({
  companyOptions,
  onFiltersChange,
  onRefreshToggle,
}) => {
  const [filters, setFilters] = useState({
    dateRange: "today",
    companies: [],
    autoRefresh: "30",
    customStartDate: null,
    customEndDate: null,
  });
  const [isAutoRefreshEnabled, setIsAutoRefreshEnabled] = useState(true);

  const dateRangeOptions = [
    { value: "today", label: "Today" },
    { value: "week", label: "This Week" },
    { value: "month", label: "This Month" },
    { value: "custom", label: "Custom" },
  ];

  // const companyOptions = [
  //   { value: "acme-corp", label: "Acme Corporation" },
  //   { value: "tech-solutions", label: "Tech Solutions Inc." },
  //   { value: "global-enterprises", label: "Global Enterprises" },
  //   { value: "innovation-labs", label: "Innovation Labs" },
  //   { value: "future-systems", label: "Future Systems" },
  //   { value: "digital-dynamics", label: "Digital Dynamics" },
  //   { value: "smart-solutions", label: "Smart Solutions" },
  //   { value: "nexus-technologies", label: "Nexus Technologies" },
  // ];

  const refreshIntervalOptions = [
    { value: "15", label: "15 minutes" },
    { value: "30", label: "30 minutes" },
    { value: "60", label: "60 minutes" },
  ];

  useEffect(() => {
    if (onFiltersChange) {
      onFiltersChange(filters);
    }
  }, [filters, onFiltersChange]);

  useEffect(() => {
    if (onRefreshToggle) {
      onRefreshToggle(isAutoRefreshEnabled, parseInt(filters.autoRefresh));
    }
  }, [isAutoRefreshEnabled, filters.autoRefresh, onRefreshToggle]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleRefreshNow = () => {
    // Emit manual refresh event
    window.dispatchEvent(new CustomEvent("manualRefresh"));
  };

  const toggleAutoRefresh = () => {
    setIsAutoRefreshEnabled(!isAutoRefreshEnabled);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        {/* Filter Controls */}
        <div className="flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={filters.dateRange}
            onChange={(value) => handleFilterChange("dateRange", value)}
            className="w-full sm:w-40"
          />
          {filters.dateRange === "custom" && (
            <div className="flex space-x-2">
              <input
                type="date"
                value={filters.customStartDate || ""}
                onChange={(e) =>
                  handleFilterChange("customStartDate", e.target.value)
                }
                className="border rounded px-2 py-1"
              />
              <span className="text-sm mt-2">to</span>
              <input
                type="date"
                value={filters.customEndDate || ""}
                onChange={(e) =>
                  handleFilterChange("customEndDate", e.target.value)
                }
                className="border rounded px-2 py-1"
              />
            </div>
          )}

          <Select
            label="Companies"
            options={companyOptions}
            value={filters.companies}
            onChange={(value) => handleFilterChange("companies", value)}
            multiple
            searchable
            clearable
            placeholder="All Companies"
            className="w-full sm:w-64"
          />
        </div>

        {/* Auto-refresh Controls */}
        <div className="flex flex-col sm:flex-row sm:items-center  space-x-4">
          <div className="flex flex-col sm:flex-row sm:items-center gap-2  space-x-2">
            <Button
              variant={isAutoRefreshEnabled ? "default" : "outline"}
              size="sm"
              onClick={toggleAutoRefresh}
              iconName={isAutoRefreshEnabled ? "Play" : "Pause"}
              iconPosition="left"
              iconSize={14}
            >
              Auto-refresh
            </Button>

            {isAutoRefreshEnabled && (
              <Select
                options={refreshIntervalOptions}
                value={filters.autoRefresh}
                onChange={(value) => handleFilterChange("autoRefresh", value)}
                className="w-32"
              />
            )}
          </div>

          <Button
            variant="outline"
            size="sm"
            onClick={handleRefreshNow}
            iconName="RefreshCw"
            iconPosition="left"
            iconSize={14}
          >
            Refresh Now
          </Button>
        </div>
      </div>

      {/* Active Filters Display */}
      {(filters.companies.length > 0 || filters.dateRange !== "today") && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center space-x-2 text-sm">
            <Icon name="Filter" size={14} className="text-muted-foreground" />
            <span className="text-muted-foreground">Active filters:</span>

            {filters.dateRange !== "today" && (
              <span className="inline-flex items-center px-2 py-1 bg-primary/10 text-primary rounded-md text-xs">
                {
                  dateRangeOptions.find(
                    (opt) => opt.value === filters.dateRange
                  )?.label
                }
              </span>
            )}

            {filters.companies.length > 0 && (
              <span className="inline-flex items-center px-2 py-1 bg-primary/10 text-primary rounded-md text-xs">
                {filters.companies.length}{" "}
                {filters.companies.length === 1 ? "Company" : "Companies"}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterControls;
